import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenerateFormService, PerForm } from '@lbmx/per-form';
import {
  SpinnerService,
  ToastrNotificationService,
} from '@lbmx/phoenix-lib-utils';
import { BaseHttpService } from '@lbmx/web-core';
import { TranslocoService } from '@ngneat/transloco';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { schemaDefinition } from './edit-option.ui';

@Component({
  selector: 'lib-edit-option-container',
  template: ` <lib-edit-option
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="save($event)"
  ></lib-edit-option>`,
  styles: ['body .ui-dialog .ui-dialog-content { overflow-auto; }']
})
export class EditOptionContainerComponent implements OnInit {
  @Input() public baseUrl: string;
  @Input() public selectedRecord: any;
  @Output() public closeDialog = new EventEmitter();
  @Output() public updateEditOption = new EventEmitter();

  public form: PerForm;
  public schemaDefinition = schemaDefinition;
  public currentFormValues;
  constructor(
    private http: BaseHttpService,
    private spinner: SpinnerService,
    private translocoService: TranslocoService,
    private toast: ToastrNotificationService,
    private formGenerator: GenerateFormService
  ) {}

  public ngOnInit(): void {
    this.http
      .fetchWithFqn({
        endpoint: `${this.baseUrl}` + '/edit-option/form',
        httpMethod: 'GET',
      })
      .pipe(
        tap(({ fields }: any) => {
          this.form = this.formGenerator.init(
            this.schemaDefinition(fields),
            this.selectedRecord
          );
        }),
        catchError(() =>
          of(
            this.toast.errorNotify(
              this.translocoService.translate('MESSAGES.GENERIC_ERROR')
            )
          )
        )
      )
      .subscribe();
  }

  public save(formValues: any) {
    this.spinner.on();
    formValues.selectedDataPreference = this.selectedRecord;
    this.http
      .fetchWithFqn({
        endpoint: `${this.baseUrl}/edit-option`,
        httpMethod: 'POST',
        body: formValues,
      })
      .pipe(
        tap((response: any) => {
          this.toast.successNotify(
            this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
          );
          this.closeDialog.emit();
          this.updateEditOption.emit();
        }),
        catchError(() =>
                of(
                  this.toast.errorNotify(
                    this.translocoService.translate('MESSAGES.GENERIC_ERROR')
                  )
                )
              ),
      finalize(() => this.spinner.off())
    )
      .subscribe();
  }
}
